import {
  IActivatable,
  ISharedContext,
  ViewModes,
  defaultContactCompany,
} from "../support/registration_form_component"
import { ContactFillingForm, ExampleContactFillingForm } from "../support/contact_filling_form"
import type { ContactTypeArray, ContactTypeName } from "../clients/config";

export type RegistrationContactInfoProps = IActivatable & ISharedContext & {
  /**
   * Contact types overrides global client contact types.
   */
  contactTypes: ContactTypeArray
  /**
   * Contact types overrides global client contact types.
   */
  contactExclusivity?: ContactTypeName[]
}
export function RegistrationContactInfo(props: RegistrationContactInfoProps) {
  if (!props.active) {
    return <div />
  }

  if (props.view_mode == ViewModes.DOWNLOADABLE) {
    return <RegistrationContactInfoStepPrintMode {...props} />
  }

  return (
    <div className="step page-break-after">
      {props.contactTypes.map(([name, contactType]) => {
        return (
          <ContactFillingForm
            {...props}
            key={name}
            name={name}
            title={contactType.title}
            description={contactType.description}
            required={contactType.required}
            showNotApplicable={contactType.showNotApplicable}
            default_company={defaultContactCompany(props.form)}
            showPlanSelection={false}
          />
        )
      })}
    </div>
  )
}

function RegistrationContactInfoStepPrintMode(props: RegistrationContactInfoProps) {
  return (
    <div className="step page-break-after">
      <h2>Step 3: Contacts Information</h2>

      <div className="page-break-after">
        <ExampleContactFillingForm {...props} />
      </div>

      <h3>Required Contacts</h3>
      {props.contactTypes.map(([name, contactType]) => {
        return (
          <ContactFillingForm
            {...props}
            key={name}
            name={name}
            title={contactType.title}
            description={contactType.description}
            required={contactType.required}
            showNotApplicable={contactType.showNotApplicable}
            default_company={defaultContactCompany(props.form)}
            showPlanSelection={false}
          />
        )
      })}
    </div>
  )
}
